import styled from 'styled-components';

export const StatusBadgeWrapperStyled = styled.div`
  display: flex;
  gap: 8px;
  min-width: 0;
  align-items: center;
`;
